import type { VoiceMessages } from '@conversed/shared/src/central/constants/voice-messages';
import type { VoiceNewBadge } from '@conversed/shared/src/central/helpers/voice-messages.helper';
import type React from 'react';

export type ActiveChatTab = 'chat' | 'voice';

type ChatVoiceTabBarProps = {
  activeTab: ActiveChatTab;
  onTabChange: (tab: ActiveChatTab) => void;
  // Used to colour the active-tab indicator to match the widget's theme
  activeColor: string;
  // Resolved for the visitor's language, admin overrides included
  messages: VoiceMessages;
  // Shown next to the voice tab label only when the admin enabled it
  newBadge?: VoiceNewBadge;
};

const ChatVoiceTabBar: React.FC<ChatVoiceTabBarProps> = ({
  activeTab,
  onTabChange,
  activeColor,
  messages,
  newBadge,
}) => {
  return (
    <div className='chat-voice-tab-bar'>
      <button
        type='button'
        className={`chat-voice-tab${activeTab === 'chat' ? ' chat-voice-tab--active' : ''}`}
        style={
          activeTab === 'chat'
            ? { color: activeColor, borderTopColor: activeColor }
            : {}
        }
        onClick={() => {
          onTabChange('chat');
        }}>
        <span className='chat-voice-tab-label' title={messages.tabs.chat}>
          {messages.tabs.chat}
        </span>
      </button>
      <button
        type='button'
        className={`chat-voice-tab${activeTab === 'voice' ? ' chat-voice-tab--active' : ''}`}
        style={
          activeTab === 'voice'
            ? { color: activeColor, borderTopColor: activeColor }
            : {}
        }
        onClick={() => {
          onTabChange('voice');
        }}>
        <span className='chat-voice-tab-label' title={messages.tabs.voice}>
          {messages.tabs.voice}
        </span>
        {newBadge && (
          <span
            className='chat-voice-tab-badge'
            title={newBadge.text}
            style={{
              backgroundColor: newBadge.backgroundColor,
              color: newBadge.textColor,
            }}>
            {newBadge.text}
          </span>
        )}
      </button>
    </div>
  );
};

export default ChatVoiceTabBar;
